import styled from 'styled-components'
import { spaces } from 'styles/mixins'

export const Container = styled.div`
  padding: ${spaces.large2};
  display: flex;
  justify-content: space-between;
`